import { render, staticRenderFns } from "./gameManage.vue?vue&type=template&id=455b5676&scoped=true"
import script from "./gameManage.vue?vue&type=script&lang=js"
export * from "./gameManage.vue?vue&type=script&lang=js"
import style0 from "./gameManage.vue?vue&type=style&index=0&id=455b5676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5676",
  null
  
)

export default component.exports